var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.ticket)?_c('h1',[_c('router-link',{attrs:{"to":_vm.previousTo}},[_vm._v(_vm._s(_vm.previousName))]),_c('v-icon',{staticClass:"ml-4"},[_vm._v("keyboard_arrow_right")]),_c('span',{staticClass:"grey--text"},[_vm._v(" "+_vm._s(_vm.currentName)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }